import React from 'react'
import { connect } from 'react-redux'
import { logout } from 'ducks/app'
import { Menu, Dropdown, Avatar, Badge, Icon } from 'antd'

const mapDispatchToProps = dispatch => ({
  logout: event => {
    event.preventDefault()
    dispatch(logout())
  },
})

const mapStateToProps = (state, props) => ({
  userState: state.app.userState,
})

@connect(
  mapStateToProps,
  mapDispatchToProps,
)
class ProfileMenu extends React.Component {
  getImageUser = photoProfile => {
    if (photoProfile) {
      return (
        <div>
          <img className="topbar__avatarImage" src={photoProfile} />
        </div>
      )
    }
  }
  render() {
    const { userState, logout } = this.props
    const menu = (
      <Menu selectable={false}>
        <Menu.Item>
          <div className="rfq__widget__system-status__item topba__menu">
            {this.getImageUser(userState.photoProfile)}
          </div>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item>
          <div className="rfq__widget__system-status__item">
            <strong>Email:</strong> {userState.email} <br />
            <div>
              <strong>Rol:</strong> {userState.role}
            </div>
          </div>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Divider />
        <Menu.Item>
          <a href="javascript: void(0);" onClick={logout}>
            <i className="topbar__dropdownMenuIcon icmn-exit" /> Cerrar sesión
          </a>
        </Menu.Item>
      </Menu>
    )
    return (
      <div className="topbar__dropdown d-inline-block">
        <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
          <a className="ant-dropdown-link" href="/">
            <Badge>
              <Avatar className="topbar__avatar" shape="square" icon="logout" />
            </Badge>
          </a>
        </Dropdown>
      </div>
    )
  }
}

export default ProfileMenu



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/TopBar/ProfileMenu/index.js